import { useEffect, useState } from 'react'

const matchQuery = (query: string) => window.matchMedia?.(query)

// Optional-chained throughout: jsdom leaves matchMedia undefined, so components
// branching on a media query must still render in tests.
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(
    () => matchQuery(query)?.matches ?? false
  )

  useEffect(() => {
    const list = matchQuery(query)
    if (!list) return
    setMatches(list.matches)
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)
    list.addEventListener?.('change', onChange)
    return () => list.removeEventListener?.('change', onChange)
  }, [query])

  return matches
}
